import "../../../styles/hubweb/overview.scss";

import { HubTab, HubTabList, HubTabPanel, HubTabs } from "./HubTabs.jsx";
import Icon, { iconTypes } from "../../common/components/Icon.jsx";

import HubOverviewList from "./HubOverviewList.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class HubOverviewCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.swallowOnClick = this.swallowOnClick.bind(this);
        this.onShowPreviousWeek = this.onShowPreviousWeek.bind(this);
        this.onShowNextWeek = this.onShowNextWeek.bind(this);
        this.calculateInternalPanelHeight = this.calculateInternalPanelHeight.bind(this);
        this.onClickShowPdf = this.onClickShowPdf.bind(this);
        this.onClickShowExcel = this.onClickShowExcel.bind(this);
        this.shouldComponentRender = this.shouldComponentRender.bind(this);
       
        this.state = { thisWeekSelected: true, start: true, tabIndexSelected: 0 };
        this.tabClick = this.tabClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        var firstTab = nextProps.overview.currentWeekProductionDates.findIndex((date) => date.isCurrentDate);

        if (firstTab >= 0 && this.state.start)
        {
            this.setState({ tabIndexSelected: firstTab, start: false });
        }       
    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    onShowPreviousWeek()
    {
        this.setState({ thisWeekSelected: true });
    }

    onShowNextWeek()
    {
        this.setState({ thisWeekSelected: false });
    }

    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder) + 45;
        return tabPanelHeight;
    }

    shouldComponentRender = () => this.props.overview.currentWeekNo;

    tabClick(e, index) {
        e.stopPropagation();
        
        this.setState({
            tabIndexSelected: index,
        });

    }

    onClickShowPdf() {
        const {
            overview,
            showOverviewPdf,
        } = this.props;

        const selectedDates = this.state.thisWeekSelected ? overview.currentWeekProductionDates : overview.nextWeekProductionDates;
        const selectedDate = selectedDates[this.state.tabIndexSelected].productionDate;

        showOverviewPdf(selectedDate);
    }

    onClickShowExcel() {
        const {
            overview,
            showOverviewExcel,
        } = this.props;

        const selectedDates = this.state.thisWeekSelected ? overview.currentWeekProductionDates : overview.nextWeekProductionDates;
        const selectedDate = selectedDates[this.state.tabIndexSelected].productionDate;

        showOverviewExcel(selectedDate);
    }

    render() {
        const {
            height,
            localization,
            setModal,
            width,
            overview,
            updateHubProductSortOrder,
            updateHubCustomerSortOrder,
            setProductsSortingMode,
            setCustomersSortingMode,
            sortProducts,
            sortCustomers,
        } = this.props;

        // Check if data has been loaded, if not just return empty component
        if (!this.shouldComponentRender()) return <div />;

        const tabPanelHeight = this.calculateInternalPanelHeight();

        const selectedDates = this.state.thisWeekSelected ? overview.currentWeekProductionDates : overview.nextWeekProductionDates;
        const selectedWeekNo = this.state.thisWeekSelected ? overview.currentWeekNo : overview.nextWeekNo;

        if(selectedDates.length > 0)
        {
            var firstTab = selectedDates.findIndex((date) => date.isCurrentDate);
             
            var firstDateOfWeek = moment(selectedDates[0].productionDate).format("DD.MM.YYYY");
            var lastDateOfWeek = moment(selectedDates[selectedDates.length-1].productionDate).format("DD.MM.YYYY");
        }

        return (
            <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height}px`, width: `${width}px` }}>
                <div className="hubmenu-row">
                    <button className="previous-week" onClick={this.onShowPreviousWeek}>
                        <Icon type={iconTypes.left}/>
                    </button>
                    <div className="month-year">{`Uke${selectedWeekNo} : ${firstDateOfWeek} - ${lastDateOfWeek} `}</div>
                    <button className="next-week" onClick={this.onShowNextWeek}>
                        <Icon type={iconTypes.right}/>
                    </button>
                    <div className="buttons">
                        <button className="btn" onClick={this.onClickShowPdf} style={{ width: "160px" }}>
                            <Icon type={iconTypes.print} />{localization.text("hub", "production", "print")}
                        </button>
                        <button className="btn" onClick={this.onClickShowExcel} style={{ width: "160px" }}>
                            <Icon type={iconTypes.print} />{localization.text("hub", "overview", "createExcel")}
                        </button>
                    </div>
                </div>
                <HubTabs startTabId={firstTab} tabClick={this.tabClick}>                    
                    <HubTabList>
                        {selectedDates.map((date, idx) => (
                            <HubTab id={idx.toString()} key={date.productionWeekDay} label={`${date.productionWeekDay} - ${moment(date.productionDate).format("DD/M")}`} disabled={date.plannedProductsForDate.length === 0} />
                        ))}
                       
                    </HubTabList>
                    {selectedDates.map((date, idx) => (
                        <HubTabPanel key={idx}>
                            <HubOverviewList
                                height={tabPanelHeight}
                                width={width}
                                customers={date.customers}
                                list={date.plannedProductsForDate}
                                localization={localization}
                                setModal={setModal}
                                updateHubProductSortOrder={updateHubProductSortOrder}
                                updateHubCustomerSortOrder={updateHubCustomerSortOrder}
                                setProductsSortingMode={setProductsSortingMode}
                                setCustomersSortingMode={setCustomersSortingMode}
                                sortProducts={sortProducts}
                                sortCustomers={sortCustomers}
                                dateIndex={idx}
                                thisWeek={this.state.thisWeekSelected}

                            />
                        </HubTabPanel>
                    ))}
                </HubTabs>
                
            </div>
        );
    }
}

HubOverviewCard.propTypes = {
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    localization: Localization.propTypes.isRequired,
    location: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    overview: PropTypes.object.isRequired,
    showOverviewPdf: PropTypes.func.isRequired,
    showOverviewExcel: PropTypes.func.isRequired,
    updateHubProductSortOrder: PropTypes.func.isRequired,
    updateHubCustomerSortOrder: PropTypes.func.isRequired,
    setProductsSortingMode:PropTypes.func.isRequired,
    setCustomersSortingMode:PropTypes.func.isRequired,
    sortProducts: PropTypes.bool.isRequired,
    sortCustomers : PropTypes.bool.isRequired,
};

HubOverviewCard.defaultProps = {
    currentView: "all",
};
export default withRouter(HubOverviewCard);
